import React from 'react';
import { ShieldCheck, HeartPulse, Brain, ScanLine, Activity, Stethoscope, Zap, FlaskConical } from 'lucide-react';

const ITEMS = [
  { icon: HeartPulse, text: 'CDSCO Approved' },
  { icon: Brain, text: 'Motor-Imagery BCI' },
  { icon: ScanLine, text: 'AI Perfusion CT / MRI' },
  { icon: Activity, text: '<30s Stroke Analysis' },
  { icon: ShieldCheck, text: 'HIPAA · DPDPA Aligned' },
  { icon: Stethoscope, text: '25+ Cities in India' },
  { icon: Zap, text: '1,000+ Patients Recovered' },
  { icon: FlaskConical, text: 'Peer-Reviewed Evidence' },
];

export default function Marquee() {
  // Duplicate list for the seamless infinite loop. Use a compound stable key.
  const rows = [
    ...ITEMS.map((it) => ({ ...it, _k: `a-${it.text}` })),
    ...ITEMS.map((it) => ({ ...it, _k: `b-${it.text}` })),
  ];
  return (
    <section className="relative py-10 bg-white border-y border-orange-100/70 overflow-hidden">
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      <div className="flex gap-10 animate-[marquee_28s_linear_infinite] whitespace-nowrap">
        {rows.map((it) => {
          const Icon = it.icon;
          return (
            <div key={it._k} className="flex items-center gap-3 flex-shrink-0">
              <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-[#FFECD9] to-[#FFD5B4] flex items-center justify-center">
                <Icon className="h-4.5 w-4.5 text-[#E85A18]" />
              </div>
              <span className="text-[14px] font-medium text-[#0F1B2D]">{it.text}</span>
              <span className="text-[#FF7A2E]">•</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
